import {
  Contribution,
  RequestCreateContribution,
  ResponseCreateAnonymousContribution,
  ResponseCreateContribution,
} from '../../../common/model/input/contributions/types';
import { postToApi } from '../common/fetchers/request-api';

const latestContributionKey = 'UPRIGHT/LATEST_CONTRIBUTION';

export async function sendContribution(contribution: { data: Contribution; target?: string }, _token: string) {
  localStorage.setItem(latestContributionKey, new Date().toJSON());
  const body: RequestCreateContribution = {
    ...contribution,
    type: contribution.data.type,
  };
  return postToApi<ResponseCreateContribution>('/contribution', body);
}

export async function sendAnonymousContribution(contribution: { data: Contribution; target?: string }) {
  const body: RequestCreateContribution = {
    ...contribution,
    type: contribution.data.type,
  };
  return postToApi<ResponseCreateAnonymousContribution>('/contribution', body);
}
